import { render, staticRenderFns } from "./newPression.vue?vue&type=template&id=2ca555e2&scoped=true&"
import script from "./newPression.vue?vue&type=script&lang=js&"
export * from "./newPression.vue?vue&type=script&lang=js&"
import style0 from "./newPression.vue?vue&type=style&index=0&id=2ca555e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca555e2",
  null
  
)

export default component.exports